import { BookingStepWidgetStyled } from "./styled";
import classNames from "classnames";
import { RENDER_BOOKING_STEP } from "utils/functions/musicHall";

const STEPS = [1, 2, 3, 4].map((step) => ({
  step,
  color: RENDER_BOOKING_STEP(step).color,
}));

const BookingStepWidget = ({ currentStep = 1, theme_table }) => {
  const customClass = classNames({
    theme_table: theme_table,
  });

  return (
    <BookingStepWidgetStyled className={customClass}>
      {STEPS.map((item, index) => {
        const isActive = currentStep >= item.step;
        return (
          <div key={item.step} className="step_item">
            <div
              className={`step_circle ${item.color} ${isActive ? "active" : ""}`}
            >
              {item.step}
            </div>
            {index < STEPS.length - 1 && <div className="step_line" />}
          </div>
        );
      })}
    </BookingStepWidgetStyled>
  );
};

export default BookingStepWidget;
